<template>
    <footer class="text-uppercase">
        <div class="container">
            <nav class="navbar navbar-expand-lg">
                <router-link :to="{name: 'index'}" class="navbar-brand mr-0 mr-md-3">
                    <img src="@/assets/img/logo.svg" class="img-fluid" alt="PcdoB" style="width: 100px; height: auto;" />
                </router-link>
                <div class="navbar-text sociais ml-2 ml-md-5 mt-3">
                    <a href="https://www.facebook.com/pcdob65/" target="_blank"><i class="ion-social-facebook"></i></a>
                    <a href="https://twitter.com/pcdob_oficial" target="_blank">
                      <img src="@/assets/img/logo-x.png" class="img-fluid" alt="PcdoB" style="margin-top: -16px;">
                    </a>
                    <a href="https://www.youtube.com/channel/UCd8GdGfoFQ2-e-PohPTyzGw" target="_blank"><i class="ion-social-youtube"></i></a>
                    <a href="https://www.instagram.com/pcdob_oficial/" target="_blank"><i class="ion-social-instagram"></i></a>
                    <router-link :to="{name: 'contato'}"><i class="ion-android-mail"></i></router-link>
                    <div class="w-100 mt-3"></div>
                    <!--
                                        Baixe o Aplicativo do PCdoB Digital <br>
                                        <a href="https://itunes.apple.com/br/app/pcdob-digital/id1229327682?mt=8" target="_blank"><img src="@/assets/img/app-store-pt.svg" alt="" style="width: 100px; height: auto;"></a>
                                        <a href="https://play.google.com/store/apps/details?id=br.org.pcdob"><img src="@/assets/img/google-play-pt.svg" alt="" style="width: 129px; height: auto; margin-left: -15px;"></a>
                    -->
                </div>

                <!--<div class="collapse navbar-collapse">-->
                    <!--<ul class="navbar-nav mr-0 ml-auto">-->
                        <!--<li class="nav-item" v-for="m in menu" v-if="m.viewFooter">-->

                            <!--<router-link v-if="m.route" :to="{name: m.route, params: m.params}" class="nav-link">-->
                                <!--{{ m.label }}-->
                            <!--</router-link>-->

                            <!--<a v-else :href="m.url" class="nav-link">{{ m.label }}</a>-->
                        <!--</li>-->
                    <!--</ul>-->
                <!--</div>-->
                <!--<div class="collapse navbar-collapse" style="margin-top: -25px;" :style="resolution < 400 ? 'display: block !important;' : 'display: none !important;'">-->
                    <!--<ul class="navbar-nav mr-0 ml-auto">-->
                        <!--<li class="nav-item">-->
                            <!--<router-link :to="{name: 'contato'}" class="nav-link text-right">Contato</router-link>-->
                        <!--</li>-->
                    <!--</ul>-->
                <!--</div>-->
            </nav>
        </div>
    </footer>
</template>

<script>
    export default {
        computed: {
            menu(){

                if(this.$store.getters.user && this.$store.getters.user.pk_id_usuario){
                    return this.$store.getters.getMenuLogado
                };

                return this.$store.getters.getMenuNaoLogado
            },
            resolution () {
                return $(document).width()
            },
        },
    }
</script>

<style scoped>
    .sociais > a > i{
        font-size: 2em;
    }
</style>



// WEBPACK FOOTER //
// src/components/includes/Footer.vue